<script>
import AreaForm from "@/views/menu/area/areaForm";
import Component, { mixins } from "vue-class-component";

@Component({
  inject: {
    areaService: "areaService",
    fileUploadService: "fileUploadService",
    toastService: "toastService",
  }
})
export default class AreaEdit extends mixins(AreaForm) {
  formId = "edit-area-form";

  get fieldColumns() {
    return 2;
  }
  get actions() {
    return [
      {
        id: "save",
        type: "submit",
        text: this.translations.labels.button_save,
        leftIcon: "mdi-content-save-outline",
        disabled: () => {
          return this.fileUploadService.isUploading();
        },
        handle: this.save,
      },
    ];
  }
  async save(action, passesValidation) {
    this.errors = [];
    if (!passesValidation) {
      return;
    }
    try {
      await this.areaService.update(this.model.id, {
        idEvent: this.model.idEvent,
        code: this.model.code,
        order: this.model.order,
      });
       this.$router.push("/area/list");
      this.toastService.success(this.translations.success.area_update);
    } catch (error) {
      this.errors = this.formatApiErrors(error);
    }
  }

  getFormTitle() {
    return this.translations.pageTitles.areas_edit;
  }

  async afterCreate () {
    this.model = await this.areaService.read(this.$route.params.id);
    this.isReady = true;
  }
}
</script>
